import { ExternalLink } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const FeedPage = lazyPage(() => import('@/pages/Feed'), 'FeedPage')

/** An external link: the sidebar opens it in a new tab, so the page is only the router's fallback. */
export const urlModule: ModuleDefinition = {
  key: 'url',
  icon: ExternalLink,
  iconName: 'external-link',
  ready: true,
  ListPage: FeedPage
}
